import { selectBuffer, selectTextTrack, selectTime } from "../store/selectors.js";
import { MEDIA_INPUT_ACTION_OVERRIDES } from "../media-actions.js";
import { isUndefined } from "@videojs/utils/predicate";
import { getTimeRangeEnd } from "@videojs/media";
//#region src/dom/hotkey/actions.ts
/** @internal */
function isHotkeyToggleAction(action) {
	return action.startsWith("toggle");
}
const HOTKEY_ACTIONS = {
	togglePaused: MEDIA_INPUT_ACTION_OVERRIDES.togglePaused,
	toggleMuted: MEDIA_INPUT_ACTION_OVERRIDES.toggleMuted,
	toggleFullscreen: MEDIA_INPUT_ACTION_OVERRIDES.toggleFullscreen,
	toggleSubtitles({ store }) {
		selectTextTrack(store.state)?.toggleSubtitles();
	},
	togglePictureInPicture: MEDIA_INPUT_ACTION_OVERRIDES.togglePictureInPicture,
	seekStep: MEDIA_INPUT_ACTION_OVERRIDES.seekStep,
	volumeStep: MEDIA_INPUT_ACTION_OVERRIDES.volumeStep,
	speedUp: MEDIA_INPUT_ACTION_OVERRIDES.speedUp,
	speedDown: MEDIA_INPUT_ACTION_OVERRIDES.speedDown,
	seekToPercent({ store, value, key }) {
		const time = selectTime(store.state);
		if (!time) return;
		const buffer = selectBuffer(store.state);
		const duration = getTimeRangeEnd({
			duration: time.duration,
			seekable: buffer?.seekable ?? []
		});
		if (duration <= 0) return;
		let percent;
		if (!isUndefined(value)) percent = value;
		else if (key >= "0" && key <= "9") percent = Number(key) * 10;
		else return;
		time.seek(percent / 100 * duration);
	}
};
/** @internal */
function resolveHotkeyAction(name) {
	return HOTKEY_ACTIONS[name];
}
//#endregion
export { isHotkeyToggleAction, resolveHotkeyAction };
